export enum VideoBitrateEnum {
  Low = 3000,
  Medium = 4500,
  High = 6000,
  VeryHigh = 8000,
}

export type VideoBitrate =
  | VideoBitrateEnum.Low
  | VideoBitrateEnum.Medium
  | VideoBitrateEnum.High
  | VideoBitrateEnum.VeryHigh;
